const footer = document.querySelector('[data-elementor-type="footer"]');
const content = document.querySelector('main#content .page-content > .elementor');


const rgba2hex = (orig) => {
  let a, isPercent,
    rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
    alpha = (rgb && rgb[4] || "").trim(),
    hex = rgb ?
      (rgb[1] | 1 << 8).toString(16).slice(1) +
      (rgb[2] | 1 << 8).toString(16).slice(1) +
      (rgb[3] | 1 << 8).toString(16).slice(1) : orig;

  if (alpha !== "") {
    a = alpha;
  } else {
    a = 0o1;
  }
  // multiply before convert to HEX
  a = ((a * 255) | 1 << 8).toString(16).slice(1)
  hex = hex + a;

  return hex;
}

const footerDivider = () => {

  if(content && footer) {

    const divider = footer.querySelector('.elementor-section:first-child');
    const lastSection = document.querySelector('main#content .page-content > .elementor > .elementor-section:last-child');

    if(lastSection && divider) {
      const color = getComputedStyle(lastSection).backgroundColor;

      if(rgba2hex(color) != 'ffffffff' && rgba2hex(color) != '00000000') {
        divider.style.display = 'none';
      }
    }
  }


}

footerDivider();
